import * as React from "react";
import PropTypes from 'prop-types';

const SvgWarningFill = props => {
  if (props.id !== "_svgwarningfill") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 24 24" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M21.37 18.848L13.276 3.724A1.393 1.393 0 0012.064 3c-.498 0-.884.277-1.135.723L2.628 18.817c-.25.446-.323 1.014-.074 1.46.25.447.74.706 1.239.706L19.975 21c.607 0 1.225-.273 1.475-.722.247-.445.167-.984-.08-1.43zM10.5 14.4h3v-6h-3v6zm1.5 1.8a1.5 1.5 0 100 3 1.5 1.5 0 000-3z" fill="#F7BD41" /></svg>;
};

SvgWarningFill.displayName = "_svgwarningfill";
SvgWarningFill.propTypes = {
  id: PropTypes.string
};
SvgWarningFill.defaultProps = {
  id: ''
};
export default SvgWarningFill;